import React, { PureComponent } from 'react';
import { Route, Switch } from 'react-router-dom';

import ChangePassword from './change-password';
import Form from './form';
import List from './list';

export default class User extends PureComponent {
  render() {
    return (
      <Switch>
        <Route component={List} exact path={this.props.match?.path} />
        <Route
          component={Form}
          exact
          path={`${this.props.match?.path}/create`}
        />
        <Route
          component={ChangePassword}
          exact
          path={`${this.props.match?.path}/:id/change-password`}
        />
        <Route
          component={Form}
          exact
          path={`${this.props.match?.path}/:id/edit`}
        />
      </Switch>
    );
  }
}
